<app-modal [activeModal]="activeModal" [onClose]="submit" [isCloseDisabled]="form.pristine" [title]="title">
  <form [formGroup]="form">
    <table class="table-striped table">
      <thead>
        <tr>
          <th i18n>Nazwa</th>
          <th i18n>Widoczność</th>
          <th i18n>Kolejność</th>
        </tr>
      </thead>
      <tbody>
        <tr *ngFor="let column of columns; let i = index">
          <td>{{ column.label }}</td>
          <td>
            <div class="form-check">
              <input type="checkbox" [formControlName]="column.key" id="{{ column.key }}" class="form-check-input" />
              <label for="{{ column.key }}" class="form-check-label cdk-visually-hidden">
                {{ column.isVisible | bool }}
              </label>
            </div>
          </td>
          <td>
            <div class="inline-flex gap-2">
              <button
                type="button"
                ndt-icon-button
                [disabled]="isFirst(i)"
                aria-label="Przesuń wyżej"
                i18n-aria-label
                (click)="moveUp(i)"
              >
                <app-icon name="arrow-up"></app-icon>
              </button>
              <button
                type="button"
                ndt-icon-button
                [disabled]="isLast(i)"
                aria-label="Przesuń niżej"
                i18n-aria-label
                (click)="moveDown(i)"
              >
                <app-icon name="arrow-down"></app-icon>
              </button>
            </div>
          </td>
        </tr>
      </tbody>
    </table>
  </form>
</app-modal>
